<div class="modal fade show d-block animate-fade-in" tabindex="-1" role="dialog"
    style="background-color: rgba(0, 0, 0, 0.8); backdrop-filter: blur(8px); z-index: 1050;">
    <div class="modal-dialog modal-dialog-centered modal-lg animate-scale-up" role="document">
        <div class="modal-content border border-secondary shadow-lg">

            <!-- Modal Header -->
            <div class="modal-header d-flex align-items-center justify-content-between">
                <div>
                    <h5 class="modal-title text-uppercase tracking-wider mb-0">Secure Checkout</h5>
                    <span class="text-secondary small text-truncate d-inline-block" style="max-width: 250px;">{{
                        item().name }}</span>
                </div>
                <button type="button" class="btn-close btn-close-white" (click)="cancelPayment()" aria-label="Close"
                    [disabled]="paymentState() === 'processing'"></button>
            </div>

            <!-- Static Header Content (Cart Summary & Payment Method Switcher) -->
            <div class="px-4 pt-4 pb-0" [class.d-none]="paymentState() === 'processing' || paymentState() === 'success' || paymentState() === 'error'">
                <!-- Simple Cart Summary -->
                <div class="p-3 mb-3 rounded-3 bg-black border border-secondary d-flex gap-3 align-items-center"
                    style="--bs-bg-opacity: 0.5;">
                    @if (item().imageUrl) {
                    <div class="rounded bg-dark border border-secondary d-flex align-items-center justify-content-center flex-shrink-0 overflow-hidden p-1"
                        style="width: 72px; height: 48px;">
                        <img [src]="item().imageUrl" class="mw-100 mh-100 object-fit-contain" alt="Icon">
                    </div>
                    } @else {
                    <div class="rounded bg-dark d-flex align-items-center justify-content-center flex-shrink-0"
                        style="width: 56px; height: 56px;">
                        <i class="bi bi-gem text-warning fs-4"></i>
                    </div>
                    }
                    <div class="flex-grow-1 min-w-0">
                        <h6 class="fw-bold text-white text-truncate mb-1 fs-6">{{ item().name }}</h6>
                        <span class="text-secondary small d-block">{{ item().description }}</span>
                    </div>
                    <div class="text-end flex-shrink-0">
                        <span class="fw-extrabold text-white d-block">${{ item().price.toFixed(2) }}</span>
                        <span class="text-secondary small">{{ item().isSubscription ? 'yearly billing' : 'one-time' }}</span>
                    </div>
                </div>

                <!-- Payment Method Selector Pills -->
                <div class="mb-2">
                    <label class="form-label text-secondary small text-uppercase fw-bold mb-2"
                        style="font-size: 0.72rem;">Choose Payment Method</label>
                    <div class="row g-2">
                        <div class="col-6">
                            <button type="button"
                                class="btn btn-payment-method w-100 py-2.5 d-flex align-items-center justify-content-center gap-2"
                                [class.active]="paymentMethod() === 'stripe'" (click)="selectMethod('stripe')">
                                <i class="bi bi-stripe fs-5" style="color: #635bff;"></i>
                                <span class="fw-bold small">Stripe</span>
                            </button>
                        </div>
                        <div class="col-6">
                            <button type="button"
                                class="btn btn-payment-method w-100 py-2.5 d-flex align-items-center justify-content-center gap-2 opacity-50"
                                disabled style="cursor: not-allowed;" title="PayPal is temporarily disabled">
                                <i class="bi bi-paypal fs-5 text-secondary"></i>
                                <span class="fw-bold small text-secondary">PayPal (Disabled)</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Modal Body (Scrollable Form Fields) -->
            <div class="modal-body">

                <!-- Stripe Form Container (Kept in DOM to prevent unmounting during confirmation) -->
                <div [class.d-none]="paymentState() === 'processing' || paymentState() === 'success' || paymentState() === 'error'"
                    class="animate-fade-in">

                    <!-- Payment Element Container -->
                    <div class="stripe-element-container mb-3">
                        <div #stripeElement class="stripe-element-mount"></div>

                        <!-- Loading overlay shown while Payment Element loads -->
                        <div *ngIf="paymentState() === 'loading_element' || paymentState() === 'idle'"
                            class="stripe-element-loading d-flex align-items-center justify-content-center py-5">
                            <div class="text-center">
                                <div class="spinner-border spinner-border-sm text-danger mb-2" role="status">
                                    <span class="visually-hidden">Loading...</span>
                                </div>
                                <p class="text-secondary small mb-0">Loading secure payment form...</p>
                            </div>
                        </div>
                    </div>

                    <!-- Recurring Agreement checkbox for subscriptions -->
                    <div *ngIf="item().isSubscription" class="form-check mb-3 text-start">
                        <input class="form-check-input bg-black border border-secondary" type="checkbox"
                            id="stripe-subscription-agree" [ngModel]="termsAccepted()"
                            (ngModelChange)="termsAccepted.set($event)" name="termsAccepted" required>
                        <label class="form-check-label text-secondary small" for="stripe-subscription-agree"
                            style="font-size: 0.78rem; line-height: 1.4;">
                            I agree to a recurring charge of <strong>${{ item().price.toFixed(2) }}
                                yearly</strong> until cancelled.
                        </label>
                    </div>

                    <div
                        class="d-flex justify-content-between align-items-center pt-3 border-top border-secondary fw-bold text-white fs-6">
                        <div class="d-flex align-items-center gap-1.5 small text-secondary fw-normal">
                            <i class="bi bi-shield-fill-check text-success me-1"></i>
                            <span style="font-size: 0.75rem;">Powered by <strong>stripe</strong></span>
                        </div>
                        <span>Total Due: <span class="text-danger">${{ item().price.toFixed(2)
                                }}</span></span>
                    </div>
                </div>

                <!-- Loading Spinner State -->
                <div *ngIf="paymentState() === 'processing'" class="text-center py-5">
                    <div class="spinner-border text-danger mb-4" role="status"
                        style="width: 3.5rem; height: 3.5rem;">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                    <h5 class="fw-bold text-white text-uppercase tracking-wide mb-2">
                        {{ processingMessage() }}
                    </h5>
                    <p class="text-secondary small mb-0">Please do not close or refresh this screen.</p>
                </div>

                <!-- Success State -->
                <div *ngIf="paymentState() === 'success'" class="text-center py-4">
                    <div class="mx-auto mb-3 d-flex align-items-center justify-content-center bg-success border border-success rounded-circle animate-scale-up"
                        style="width: 72px; height: 72px; --bs-bg-opacity: 0.1; box-shadow: 0 0 20px rgba(25, 135, 84, 0.15);">
                        <i class="bi bi-patch-check-fill text-success" style="font-size: 3rem;"></i>
                    </div>
                    <h4 class="fw-extrabold text-white text-uppercase mb-2">Order Approved!</h4>
                    <p class="text-secondary small mb-4 px-2">
                        @if (item().isSubscription) {
                        Thank you for upgrading! Your {{ item().name }} benefits are now active.
                        } @else {
                        Thank you for your purchase. "{{ item().name }}" is now unlocked and available on your
                        profile!
                        }
                    </p>
                </div>

                <!-- Error State -->
                <div *ngIf="paymentState() === 'error'" class="text-center py-4">
                    <div class="mx-auto mb-3 d-flex align-items-center justify-content-center bg-danger border border-danger rounded-circle animate-scale-up"
                        style="width: 72px; height: 72px; --bs-bg-opacity: 0.1; box-shadow: 0 0 20px rgba(232, 64, 87, 0.15);">
                        <i class="bi bi-exclamation-triangle-fill text-danger" style="font-size: 2.5rem;"></i>
                    </div>
                    <h5 class="fw-extrabold text-white text-uppercase mb-2">Payment Error</h5>
                    <p class="text-secondary small mb-4 px-2">{{ errorMessage() }}</p>
                </div>

            </div>

            <!-- Modal Footer (Action buttons matching global modal styles, pinned to modal bottom) -->
            <div class="modal-footer p-0 border-top border-secondary gap-0" *ngIf="paymentState() !== 'processing'">
                @switch (paymentState()) {
                @case ('idle') {
                <ng-container *ngTemplateOutlet="footerButtons"></ng-container>
                }
                @case ('loading_element') {
                <ng-container *ngTemplateOutlet="footerButtons"></ng-container>
                }
                @case ('ready') {
                <ng-container *ngTemplateOutlet="footerButtons"></ng-container>
                }
                @case ('success') {
                <button type="button" class="btn btn-danger w-100 m-0 rounded-0 rounded-bottom fw-bold"
                    style="height: 4rem;" (click)="cancelPayment()">
                    Done
                </button>
                }
                @case ('error') {
                <button type="button" class="btn btn-dark w-50 m-0 rounded-0 rounded-bottom-start fw-bold"
                    style="height: 4rem;" (click)="cancelPayment()">
                    Close
                </button>
                <button type="button" class="btn btn-danger w-50 m-0 rounded-0 rounded-bottom-end fw-bold"
                    style="height: 4rem;" (click)="retryPayment()">
                    <i class="bi bi-arrow-clockwise me-1"></i> Retry
                </button>
                }
                }
            </div>

            <!-- Shared footer buttons template for idle/loading/ready states -->
            <ng-template #footerButtons>
                <button type="button" class="btn btn-dark w-50 m-0 rounded-0 rounded-bottom-start fw-bold"
                    style="height: 4rem;" (click)="cancelPayment()">
                    Cancel
                </button>

                @if (paymentMethod() === 'stripe') {
                <button type="button" class="btn btn-danger w-50 m-0 rounded-0 rounded-bottom-end fw-bold"
                    style="height: 4rem;"
                    [disabled]="paymentState() !== 'ready' || !isFormComplete() || (item().isSubscription && !termsAccepted())"
                    (click)="submitPayment()">
                    Pay with Stripe
                </button>
                } @else {
                <button type="button" class="btn btn-paypal-checkout w-50 m-0 rounded-0 rounded-bottom-end fw-bold"
                    style="height: 4rem;" (click)="submitPayment()">
                    <i class="bi bi-paypal fs-5 me-1"></i> Proceed to PayPal
                </button>
                }
            </ng-template>

        </div>
    </div>
</div>